import {Component} from '@angular/core';

@Component({
    selector: 'nirby-select-tutorial-panel',
    templateUrl: './select-tutorial-panel.component.html',
    styleUrls: ['./select-tutorial-panel.component.scss'],
})
export class SelectTutorialPanelComponent {
}
